/**
 * The sign-up's age rules, shared by SignupFlow and the share page's light sign-up sheet
 * (game-on-freeform U17) so the two cannot drift: an age only from a full date; email and
 * the Terms box from 13; a grown-up from 18.
 */
export function computeAge(birthdate: string): number | null {
  if (!birthdate) return null;
  const parts = birthdate.split("-");
  const year = parseInt(parts[0] || "", 10);
  if (!year || year < 1000 || parts.length < 3) return null;
  const birth = new Date(birthdate);
  if (isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
}

/** Email is required, and Terms are accepted by the account holder, from 13. */
export const needsEmailAndTerms = (age: number | null): boolean => age !== null && age >= 13;

export const isGrownUp = (age: number | null): boolean => age !== null && age >= 18;
